import { BlockStack, Box, DataTable, InlineGrid, SkeletonThumbnail, Text, Thumbnail, Button, InlineStack } from '@shopify/polaris';
import { LabelPrinterIcon } from '@shopify/polaris-icons';
import { useState, useMemo } from 'react';
import PURCHASE_ORDER_STRINGS from '#client/pages/PurchaseOrders/constants/purchaseOrders.en.json';
import { getProductInfo } from '#client/pages/PurchaseOrders/utils/helpers';
import PrintLabelsModal from '#client/pages/PurchaseOrders/PurchaseOrderReceivingDocument/components/PurchaseOrderLineItemsTable/components/PrintLabelsModal';

const ExpectedItemsTable = ({ expectedRows, expectedSortColumnIndex, expectedSortDirection, setExpectedSortColumnIndex, setExpectedSortDirection, handleSort, setExpectedRows }) => {
    const columnKeyMap = ['product', 'sku', 'quantityExpected', 'quantityReceived', 'netSuiteHumanLineNumber', 'stockDescription', 'itemNumberSourcing'];

    // Print Labels Modal state
    const [printLabelsModalOpen, setPrintLabelsModalOpen] = useState(false);

    // Prepare variants data for the modal
    const modalVariants = useMemo(() => {
        return expectedRows.map((row) => ({
            key: row.sku,
            quantity: row.quantityReceived || 0,
            sku: row.sku,
            productName: row.product || 'Unknown Product',
            amazonSku: row.amazonSku || null,
            barcode: row.barcode || null,
        }));
    }, [expectedRows]);

    return (
        <>
            <InlineStack align="space-between" gap="200">
                <Text variant="headingLg">{PURCHASE_ORDER_STRINGS.PURCHASE_ORDER_DETAIL.EXPECTED_ITEMS_TABLE.EXPECTED_ITEMS}</Text>
                <Button variant="secondary" icon={LabelPrinterIcon} onClick={() => setPrintLabelsModalOpen(true)} disabled={expectedRows.length === 0}>
                    Print Labels For Items
                </Button>
            </InlineStack>
            <DataTable
                columnContentTypes={['text', 'text', 'text', 'text', 'text', 'text', 'text']}
                headings={[
                    `${PURCHASE_ORDER_STRINGS.PRODUCT}`,
                    `${PURCHASE_ORDER_STRINGS.SKU}`,
                    `${PURCHASE_ORDER_STRINGS.QTY_EXPECTED}`,
                    `${PURCHASE_ORDER_STRINGS.QTY_RECEIVED}`,
                    `${PURCHASE_ORDER_STRINGS.NETSUITE_LINE_NUMBER}`,
                    `${PURCHASE_ORDER_STRINGS.STOCK_DESCRIPTION}`,
                    `${PURCHASE_ORDER_STRINGS.ITEM_NUMBER_SOURCING}`,
                ]}
                rows={expectedRows.map((row, index) => {
                    const productInfo = getProductInfo(row);
                    return [
                        <InlineGrid columns="auto 1fr auto" key={`product-grid-${row.sku}-${index}`}>
                            {row.variantImage ? <Thumbnail source={row.variantImage} alt={row.imageAlt || PURCHASE_ORDER_STRINGS.PRODUCT_IMAGE} size="small" /> : <SkeletonThumbnail size="small" />}
                            <BlockStack>
                                <Box paddingInlineStart="300">
                                    <Text as="span" variant="headingSm" fontWeight={productInfo.textWeight} tone={productInfo.tone}>
                                        {productInfo.productName}
                                    </Text>
                                </Box>
                            </BlockStack>
                        </InlineGrid>,
                        <BlockStack key={`row-sku=${index}`} gap="100">
                            <Text>{row.sku || '---'}</Text>
                        </BlockStack>,
                        row.quantityExpected,
                        row.quantityReceived,
                        row.netSuiteHumanLineNumber || '---',
                        row.stockDescription || '---',
                        row.itemNumberSourcing || '---',
                    ];
                })}
                sortable={[true, true, true, true]}
                defaultSortDirection="none"
                onSort={(index, direction) => {
                    setExpectedSortColumnIndex(index);
                    setExpectedSortDirection(direction);
                    setExpectedRows(handleSort(expectedRows, index, direction, columnKeyMap));
                }}
                sortDirection={expectedSortDirection}
                sortedColumnIndex={expectedSortColumnIndex}
            />

            <PrintLabelsModal open={printLabelsModalOpen} onClose={() => setPrintLabelsModalOpen(false)} variants={modalVariants} />
        </>
    );
};

export default ExpectedItemsTable;
